import * as React from "react";

const SvgCliproFilled = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 21 20"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.63483 14.1562V15C2.63483 16.1046 3.53026 17 4.63483 17H9.5H13.5H14.6348C15.7394 17 16.6348 16.1046 16.6348 15L16.6348 5C16.6348 3.89543 15.7394 3 14.6348 3H13.5H9.5H4.63483C3.53026 3 2.63483 3.89543 2.63483 5V5.84365H4.13483V5C4.13483 4.72386 4.35868 4.5 4.63483 4.5L7.56301 4.5C7.52188 4.65981 7.5 4.82735 7.5 5V15C7.5 15.1726 7.52188 15.3402 7.56301 15.5H4.63483C4.35869 15.5 4.13483 15.2761 4.13483 15V14.1562H2.63483ZM19 4.75C19 4.33579 19.3358 4 19.75 4C20.1642 4 20.5 4.33579 20.5 4.75V15.25C20.5 15.6642 20.1642 16 19.75 16C19.3358 16 19 15.6642 19 15.25V4.75Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.37435 13.3724C9.04592 13.6278 8.56738 13.3938 8.56738 12.9777V7.02232C8.56738 6.60625 9.04592 6.3722 9.37435 6.62764L13.2028 9.60532C13.4602 9.8055 13.4602 10.1945 13.2028 10.3947L9.37435 13.3724Z"
      fill="#333333"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.2667 10.0576L2.59492 9.43845C2.40582 9.53193 2.19332 9.58548 1.96829 9.58798C1.16633 9.59689 0.508988 8.95399 0.500079 8.15203C0.49117 7.35007 1.13407 6.69273 1.93603 6.68382C2.73799 6.67491 3.39533 7.31781 3.40424 8.11977C3.40657 8.32959 3.36428 8.52952 3.2862 8.71052L3.99074 9.3599L5.67678 7.74507C5.76815 7.65756 5.8894 7.60808 6.01591 7.60667C6.46697 7.60166 6.69203 8.15074 6.36722 8.46375L4.73011 10.0414L6.40186 11.5823C6.73355 11.888 6.52074 12.4419 6.06968 12.4469C5.94316 12.4483 5.82085 12.4016 5.72755 12.3161L4.00607 10.7391L3.31612 11.404C3.3982 11.5832 3.44492 11.7822 3.44725 11.992C3.45616 12.7939 2.81327 13.4513 2.01131 13.4602C1.20934 13.4691 0.552003 12.8262 0.543094 12.0242C0.534186 11.2223 1.17708 10.5649 1.97904 10.556C2.20407 10.5535 2.41771 10.6024 2.60884 10.6916L3.2667 10.0576Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.98989 11.5243C1.72257 11.5273 1.50827 11.7464 1.51124 12.0137C1.51421 12.281 1.73332 12.4953 2.00064 12.4923C2.26796 12.4894 2.48226 12.2703 2.47929 12.0029C2.47632 11.7356 2.25721 11.5213 1.98989 11.5243Z"
      fill="#333333"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.95755 8.62003C2.22487 8.61706 2.43917 8.39794 2.4362 8.13062C2.43323 7.8633 2.21412 7.649 1.9468 7.65197C1.67947 7.65494 1.46518 7.87405 1.46815 8.14138C1.47112 8.4087 1.69023 8.62299 1.95755 8.62003Z"
      fill="#333333"
    />
  </svg>
);

export default SvgCliproFilled;
